<nav class="navbar sticky-top navbar-expand-lg navbar-white bg-white border-bottom">
  <div class="container">
    <a class="navbar-brand" href="https://easymarketingred.es/">
      <img src="https://easymarketingred.es/content/images/cupra-logo.png" alt="CUPRA Easy Marketing Red" width="395" height="60">
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" [routerLink]="['/admin/home']"><i class="fa fa-th" aria-hidden="true"></i> Inicio</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" [routerLink]="['/admin/carmodel']"><i class="fa fa-car" aria-hidden="true"></i> Vehículos</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" [routerLink]="['/admin/configuration-loader']"><i class="fa fa-cog" aria-hidden="true"></i> Configuraciones</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" [routerLink]="['/admin/pieza-desgaste-loader']"><i class="fa fa-wrench" aria-hidden="true"></i> Piezas de desgaste</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" [routerLink]="['/admin/budget']"><i class="fa fa-file-text-o" aria-hidden="true"></i> Presupuestos</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<div [@routeAnimations]="prepareRoute(outlet)">
  <router-outlet #outlet="outlet"></router-outlet>
</div>
<footer class="fixed-bottom">
  <div class="container">
    <div class="row">
      <div class="col-md-2">© 2022 CUPRA
      </div>
      <div class="col-md-10 text-end">
        <strong>Horario:</strong> Lunes-Jueves 8:30-16:00h &nbsp;|&nbsp; Viernes 8:00-14:00h &nbsp;|&nbsp; <a style="text-decoration:none;" href="mailto:secretaria@easymarketingred.es">secretaria@easymarketingred.es</a>
      </div>
    </div>
  </div>
</footer>
